<template>
  <a-spin tip="Your document is being processed, do not leave this page!" :spinning="pageLoading">
    <div class="wrapper">
      <div class="wrapper-header">
        <span>
          <a-icon type="wallet" class="margin-right-small" />
          Monitoring Tax Invoice
        </span>
        <a-button @click="handleReload" size="small" icon="reload"></a-button>
      </div>
      <div class="wrapper-body">
        <a-card>
          <div style="display: none">
            <a-select placeholder="Ex: Need Process ... " v-model="tabs.active" :disabled="true" @change="moreSearch"
              class="width-full" initialValue="process" allowClear>
              <a-select-option value="release">release</a-select-option>
              <a-select-option value="queue">queue</a-select-option>
              <a-select-option value="needprocess">needprocess</a-select-option>
            </a-select>
          </div>
          <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 21 }">
              <a-input-search v-model="search" placeholder="Quick Search" />
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
              <div style="width:100%;text-align:center">
                <a-button :class="getScreen ? 'margin-top' : ''" :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
                  @click="handleshowMore">{{
                    advancedsearch == "display:none" ? "More" : "Less"
                  }}</a-button>
                &nbsp;
                <!-- <a-button
                  type="primary"
                  icon="plus"
                  @click="handleShowModalCreate"
                  :loading="loading.create"
                >
                  Tax Manual
                </a-button> -->
              </div>
            </a-col>
          </a-row>
          <a-row :style="advancedsearch" :gutter="8" class="margin-top">
            <!-- <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
              <div class="m-form-item-wrapper">
                <label>Transaction Date</label>
                <a-range-picker
                  :placeholder="['Start Date', 'End Date']"
                  v-model="transactionDt"
                  :format="getDefaultDateFormat"
                  allowClear
                />
              </div>
            </a-col> -->
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <div class="m-form-item-wrapper">
                <label>Tax Date</label>
                <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="taxDt" :format="getDefaultDateFormat"
                  allowClear />
              </div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <div class="m-form-item-wrapper">
                <label>Type</label>
                <a-select placeholder="Ex: All Type ... " v-model="type" class="width-full" initialValue="all">
                  <a-select-option value="all">All Type</a-select-option>
                  <a-select-option value="account_pay"> ACCOUNT PAY </a-select-option>
                  <a-select-option value="account_receivable"> ACCOUNT RECEIVABLE </a-select-option>
                  <a-select-option value="account_receivable_sales_contract"> ACCOUNT RECEIVABLE SALES CONTRACT
                  </a-select-option>
                  <a-select-option value="adendum"> ADENDUM </a-select-option>
                  <a-select-option value="other_income"> OTHER INCOME </a-select-option>
                  <a-select-option value="other_outcome"> OTHER OUTCOME </a-select-option>
                  <a-select-option value="pi"> PI </a-select-option>
                  <a-select-option value="pi_release"> PI RELEASE </a-select-option>
                  <a-select-option value="po"> PO </a-select-option>
                  <a-select-option value="tax_manual"> TAX MANUAL </a-select-option>
                  <a-select-option value="tax_verification"> TAX VERIFICATION </a-select-option>
                  <a-select-option value="wo"> WO </a-select-option>
                </a-select>
              </div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <div class="m-form-item-wrapper">
                <label>Tax Type</label>
                <a-select placeholder="Ex: All Type ... " v-model="typetransaction" class="width-full" initialValue="all">
                  <a-select-option value="all">All Tax Type</a-select-option>
                  <a-select-option v-for="item in getType_tax" :key="item.value" :value="item.value">
                    {{ item.text }}
                  </a-select-option>

                  <!--a-select-option value="all">All transaction</!--a-select-option>
                  <a-select-option value="PO">PO</a-select-option>
                  <a-select-option value="WO">WO</a-select-option>
                  <a-select-option v-if="tabs.active=='queue'" value="Adendum">Addendum</a-select-option>
                  <a-select-option value="Adendum">Adendum</a-select-option> -->
                </a-select>
              </div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" class="margin-top">
              <div class="m-form-item-wrapper">
                <label>Rectification Available</label>
                <a-select placeholder="Ex: All Data ... " v-model="recavai" class="width-full" initialValue="all">
                  <a-select-option value="all">All Data</a-select-option>
                  <a-select-option value="1"> Available </a-select-option>
                  <a-select-option value="0"> Not Available </a-select-option>
                </a-select>
              </div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" class="margin-top">
              <div class="m-form-item-wrapper">
                <label>Document Type</label>
                <a-select placeholder="Ex: All Document Type ... " v-model="doctype" class="width-full"
                  initialValue="all">
                  <a-select-option value="all">All Data</a-select-option>
                  <a-select-option value="Dokumen Faktur Pajak"> Dokumen Faktur Pajak </a-select-option>
                  <a-select-option value="Bukti Potong Pajak"> Bukti Potong Pajak </a-select-option>
                  <a-select-option value="Dokumen STP">Dokumen STP</a-select-option>
                  <a-select-option value="Dokumen Id Billing">Dokumen Id Billing</a-select-option>
                </a-select>
              </div>
            </a-col>
          </a-row>
        </a-card>
        <div class="bordered">
          <a-tabs class="custom-tabs" :activeKey="tabs.active" @change="handleTab">
            <a-tab-pane key="needprocess">
              <template slot="tab">
                <span>List Tax Invoice</span>&nbsp;
                <a-badge class="m-badge m-badge-small" :count="needProcess.length"
                  :numberStyle="{ backgroundColor: 'red' }" v-if="needProcess.length > 0 && tabs.active == 'needprocess'">
                </a-badge>
              </template>
              <a-table :rowKey="(record, index) => {
                  return index.toString();
                }
                " size="small" bordered :scroll="{ x: 1300 }" :columns="columns.needProcess" :dataSource="needProcess"
                :loading="tabs.loading" :pagination="pagination">
                <template slot="nomor" slot-scope="text, data, index">
                  <span>{{
                    (pagination.page - 1) * pagination.pageSize + index + 1
                  }}</span>
                </template>
                <template slot="tlc" slot-scope="text">
                  <div style="width:100%;text-align:center">
                    <span>{{ text }}</span>
                  </div>
                </template>
                <template slot="trans_dt" slot-scope="text, data">
                  <span>{{
                    data.tax_date
                    ? moment(data.tax_date).format(getDefaultDateFormat)
                    : ""
                  }}</span>
                </template>
                <template slot="no_trans" slot-scope="text, data">
                  <span v-if="data.type == 'tax_manual'">{{
                    data.no_trans
                  }}</span>
                  <a v-else-if="data.type == 'tax_verification'" @click="handlelinkTaxVerivication(data)">{{ data.no_trans
                  }}</a>
                  <a v-else @click="handlelinkNo(data)">{{ data.no_trans }}</a>
                </template>
                <template slot="tax_dt" slot-scope="text, data">
                  <span>{{
                    data.tax_date
                    ? moment(data.tax_date).format(getDefaultDateFormat)
                    : "-"
                  }}</span>
                </template>
                <template slot="value_dpp" slot-scope="text, data">
                  <div style="width:100%">
                    <span style="float:right">{{
                      formatCurrency("IDR", data.value_dpp)
                    }}</span>
                  </div>
                </template>
                <template slot="value" slot-scope="text, data">
                  <div style="width:100%">
                    <span style="float:right">{{
                      formatCurrency("IDR", data.value)
                    }}</span>
                  </div>
                </template>
                <template slot="document_tax" slot-scope="text, data">
                  <div style="width:100%;text-align:center">
                    <a-button icon="file" v-if="!(
                          data.document_tax &&
                          data.document_tax == 'No File Uploaded'
                        )
                        " @click="handleviewAttacment(data)">View Document</a-button>
                    <a-button v-else :disabled="true">No File Uploaded</a-button>
                  </div>
                </template>
                <template slot="createby" slot-scope="text, data">
                  <div style="text-align:center">
                    {{ data.tlc_create }} /
                    {{ moment(data.date_create).format(getStandartFormatDate) }}
                  </div>
                </template>
                <template slot="object_deposite" slot-scope="text, data">
                  <span>{{
                    data.kode_setoran_pajak ? data.kode_setoran_pajak : "-"
                  }}
                    /
                    {{
                      data.kode_objek_pajak ? data.kode_objek_pajak : "-"
                    }}</span>
                </template>

                <template slot="aksi" slot-scope="text, data">
                  <a-button :disabled="data.pembetulan == '0'" @click="handleRectification('transaction', data)"
                    :loading="modalPembetulan.loading && modalPembetulan.key == data.id_tax_transaction" icon="form"
                    type="primary">Rectification</a-button>
                </template>
              </a-table>
            </a-tab-pane>
            <a-tab-pane key="list_tax_rectification">
              <template slot="tab">
                <span>List Rectification</span>
              </template>
              <a-table :rowKey="(record, index) => {
                return index.toString();
              }
                " size="small" bordered :scroll="{ x: 1000 }" :columns="columns.listRectification"
                :dataSource="listRectification" :loading="tabs.loading" :pagination="paginationlist">
                <template slot="nomor" slot-scope="text, data, index">
                  <span>{{
                    (paginationlist.page - 1) * paginationlist.pageSize + index + 1
                  }}</span>
                </template>
                <template slot="tlc" slot-scope="text">
                  <div style="width:100%;text-align:center">
                    <span>{{ text }}</span>
                  </div>
                </template>
                <template slot="trans_dt" slot-scope="text, data">
                  <span>{{
                    data.tax_date
                    ? moment(data.tax_date).format(getDefaultDateFormat)
                    : ""
                  }}</span>
                </template>
                <template slot="no_trans" slot-scope="text, data">
                  <span v-if="data.type == 'tax_manual'">{{
                    data.no_trans
                  }}</span>
                  <a v-else-if="data.type == 'tax_verification'" @click="handlelinkTaxVerivication(data)">{{ data.no_trans
                  }}</a>
                  <a v-else @click="handlelinkNo(data)">{{ data.no_trans }}</a>
                </template>
                <template slot="tax_dt" slot-scope="text, data">
                  <span>{{
                    data.tax_date
                    ? moment(data.tax_date).format(getDefaultDateFormat)
                    : "-"
                  }}</span>
                </template>
                <template slot="value_dpp" slot-scope="text, data">
                  <div style="width:100%">
                    <span style="float:right">{{
                      formatCurrency("IDR", data.value_dpp)
                    }}</span>
                  </div>
                </template>
                <template slot="value" slot-scope="text, data">
                  <div style="width:100%">
                    <span style="float:right">{{
                      formatCurrency("IDR", data.value_new)
                    }}</span>
                  </div>
                </template>
                <template slot="document_tax" slot-scope="text, data">
                  <div style="width:100%;text-align:center">
                    <a-button icon="file" v-if="!(
                          data.document_tax &&
                          data.document_tax == 'No File Uploaded'
                        )
                        " @click="handleviewAttacment(data)">View Document</a-button>
                    <a-button v-else :disabled="true">No File Uploaded</a-button>
                  </div>
                </template>
                <template slot="createby" slot-scope="text, data">
                  <div style="text-align:center">
                    {{ data.tlc_create }} /
                    {{ moment(data.date_create).format(getStandartFormatDate) }}
                  </div>
                </template>
                <template slot="tipe" slot-scope="text, data">
                  {{ data.type_rectification == 'rectification_non_value' ? "Non Value" : "Value" }}
                </template>
                <template slot="object_deposite" slot-scope="text, data">
                  <span>{{
                    data.kode_setoran_pajak ? data.kode_setoran_pajak : "-"
                  }}
                    /
                    {{
                      data.kode_objek_pajak ? data.kode_objek_pajak : "-"
                    }}</span>
                </template>

                <template slot="aksi" slot-scope="text, data">
                  <a-button :disabled="data.pembetulan == '0'" @click="handleRectification('manifest', data)"
                    :loading="modalPembetulan.loading && modalPembetulan.key == data.tax_rectification_id" icon="eye"
                    type="primary">Manifest</a-button>
                </template>
              </a-table>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>

      <TaxDepositEntry :v-if="modalDepositEntry" :visibleTaxModal="modalDepositEntry" :getType_tax="getType_tax"
        :getListsetoranpajak="dataEdit.listsetoranpajak" :getListobjekpajak="dataEdit.listobjekpajak"
        :tax_type="dataEdit.tax_type" :file_document_tax="dataEdit.document_tax"
        :kode_setoran_pajak="dataEdit.kode_setoran_pajak" :objek_pajak="dataEdit.kode_objek_pajak"
        :id_header="dataEdit.id_transaction" :id_dtl="dataEdit.id_dtl_transaction" :dpp_value="dataEdit.value_dpp"
        :value="dataEdit.value" :file="dataEdit.fileList" :jenis_transaksi="dataEdit.type"
        :type_document="dataEdit.type_document" :no_document="dataEdit.no_document" :tgl_document="dataEdit.tgl_document"
        :modeedit="true" />

      <a-modal v-model="modalCreate" v-if="modalCreate" @ok="handleModalCreate" @cancel="handleModalClose"
        :maskClosable="false" :width="800" :footer="null">
        <span slot="title"> <a-icon type="code" />&nbsp;Manual Tax </span>

        <a-form :form="formcreate">
          <a-row :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Jenis Anggaran">
                <a-select showSearch :not-found-content="null" option-filter-prop="children" v-decorator="[
                  'jenis_anggaran',
                  {
                    rules: [{ required: true }],
                    initialValue: dataEdit.jenis_anggaran,
                  },
                ]" @change="handleJenisAnggaran">
                  <a-select-option v-for="item in modalData.jenis_anggaran" :key="item.value">{{ item.text
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Cost Center">
                <a-select :disabled="modalData.costcenter.length == 0" showSearch v-decorator="[
                  'cost_center',
                  {
                    rules: [{ required: true }],
                    initialValue: dataEdit.cost_center,
                  },
                ]" @change="handleCost">
                  <a-select-option v-for="item in modalData.costcenter" :key="item.value">{{ item.text }} ({{
                    item.nama_pekerjaan ? item.nama_pekerjaan : "-"
                  }})</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Peruntukan">
                <a-select :disabled="modalData.peruntukan.length == 0" showSearch v-decorator="[
                  'peruntukan',
                  {
                    rules: [{ required: true }],
                    initialValue: dataEdit.peruntukan,
                  },
                ]" @change="handle_Peruntukan" ref="refperuntukan" optionFilterProp="children"
                  :filterOption="filterOption">
                  <a-select-option v-for="item in modalData.peruntukan" :key="item.value">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Budget Code">
                <a-tree-select v-decorator="[
                  'kode_anggaran',
                  {
                    rules: [{ required: true }],
                    initialValue: dataEdit.treekode_anggaran,
                  },
                ]" show-search style="width: 100%" @select="handlechoiceCost"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="modalData.anggaran.tree"
                  treeNodeFilterProp="children" :filterTreeNode="filterTreeNode" placeholder="Please select"
                  :treeExpandedKeys="modalData.treeExpandedKeys" allow-clear :disabled="modalData.anggaran.loadingtree ||
                    modalData.anggaran.tree == undefined ||
                    modalData.anggaran.tree.length == 0
                    " tree-default-expand-all>
                  <span slot="title" slot-scope="item">
                    <table style="width:100%">
                      <tr>
                        <td>
                          <span>{{ item.texttitle }} -
                            {{ item.kode_anggaran }}</span>
                        </td>
                        <td>
                          <span style="float:right"><b>{{
                            formatRupiah(parseFloat(item.rekap))
                          }}</b></span>
                        </td>
                      </tr>
                    </table>
                  </span>
                  <template slot="suffixIcon"><a-icon :type="modalData.anggaran.loadingtree ? 'loading' : 'down'
                      " />
                  </template>
                </a-tree-select>
              </a-form-item>
              <a-form-item label="Note">
                <a-textarea placeholder="Write the note here ... " :rows="2" v-decorator="[
                  'description',
                  {
                    rules: [{ required: false }],
                    initialValue: dataEdit.description,
                  },
                ]" />
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-row :gutter="8">
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <a-form-item label="Date of Tax">
                    <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat" v-decorator="[
                      'tax_date',
                      {
                        rules: [{ required: true }],
                        initialValue: dataEdit.date_of_tax
                          ? moment(dataEdit.date_of_tax)
                          : null,
                      },
                    ]" />
                  </a-form-item>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <a-form-item label="Tax Type">
                    <a-select v-decorator="[
                      'tax_type',
                      {
                        rules: [{ required: true }],
                        initialValue: dataEdit.type_pajak,
                      },
                    ]" show-search optionFilterProp="children" :filterOption="filterOption"
                      @change="handleChangeTaxType">
                      <a-select-option v-for="item in listtax" :key="item.value" :value="item.value">
                        {{ item.text }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-form-item label="Tax Deposit">
                <a-select v-decorator="[
                  'kode_setoran_pajak',
                  {
                    rules: [{ required: true }],
                    initialValue: dataEdit.tax_deposit,
                  },
                ]" option-filter-prop="children" :filter-option="filterOption" showSearch>
                  <a-select-option v-for="item in modalData.listsetoranpajak" :key="item.value" :value="item.value"
                    :text="item.text">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Tax Object" v-if="!(
                  modalData.reftax_type == 'pph_21' ||
                  modalData.reftax_type == 'ppn'
                )
                ">
                <a-select v-decorator="[
                  'objek_pajak',
                  {
                    rules: [{ required: false }],
                    initialValue: dataEdit.tax_object,
                  },
                ]" option-filter-prop="children" :filter-option="filterOption" showSearch allowClear>
                  <a-select-option v-for="item in modalData.listobjekpajak" :key="item.value" :value="item.value"
                    :text="item.text">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="DPP Value">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
    'dpp_value',
    {
      rules: [{ required: true, validator: checkPrice }],
      initialValue: dataEdit.dpp_value,
    },
  ]" />
              </a-form-item>
              <a-form-item label="Tax Value">
                <a-input-number type="number" class="m-width-full m-text-align-right"
                  v-on:keydown.enter.prevent="preventEnterButton" :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
    'value',
    {
      rules: [{ required: true, validator: checkPrice }],
      initialValue: dataEdit.tax_value,
    },
  ]" />
              </a-form-item>
              <a-form-item label="File Document Tax">
                <a-upload :fileList="modalData.fileList" v-decorator="[
                  'file_document_tax',
                  {
                    rules: [
                      { required: false, validator: doc_validation },
                    ],
                  },
                ]" :remove="handleRemoveAttachment" :beforeUpload="beforeUploadAttachment">
                  <a-button> <a-icon type="upload" />Select File </a-button>
                </a-upload>
              </a-form-item>
            </a-col>
          </a-row>
          <div class="container-essential" v-if="this.modalData.modeedit && this.modalData.fileList.length > 0">
            <a-row :gutter="12">
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <a-form-item label="Date Document">
                  <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat" v-decorator="[
                    'tgl_document',
                    {
                      rules: [{ required: true }],
                      initialValue: dataEdit.tgl_document ? moment(dataEdit.tgl_document) : null,
                    },
                  ]" />
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <a-form-item label="Type Document">
                  <a-select
                    v-decorator="['type_document', { rules: [{ required: true }], initialValue: dataEdit.type_document }]">
                    <a-select-option value="Dokumen Faktur Pajak">Dokumen Faktur Pajak</a-select-option>
                    <a-select-option value="Bukti Potong Pajak">Bukti Potong Pajak</a-select-option>
                    <a-select-option value="Dokumen STP">Dokumen STP</a-select-option>
                    <a-select-option value="Dokumen Id Billing">Dokumen Id Billing</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
                <a-form-item label="No Document">
                  <a-input
                    v-decorator="['no_document', { rules: [{ required: true }], initialValue: dataEdit.no_document }]"></a-input>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <a-button type="primary" icon="disk" @click="handleCreateTaxManual" ref="addMainBtn"
            :loading="loading.createtaxmanual" class="m-width-full margin-top">
            Save
          </a-button>
        </a-form>
      </a-modal>

      <a-modal v-model="modalTaxVerification" v-if="modalTaxVerification" :maskClosable="false" :width="1024"
        :footer="null">
        <!-- @ok="handleModalProcess"
          @cancel="handleModalClose" -->
        <span slot="title"> <a-icon type="reconciliation" />&nbsp;Verification Transaction Tax
          {{ modalTax.jenis_transaksi_label }} # {{ modalTax.no_transaction }} </span>
        <div class="container-headertable">
          <div class="m-display-flex space-between align-middle">
            <span>List Details</span>
            <!-- <a-button 
                  v-if="loading.loadJenis != 'view'"
                  @click="handleExpand()"
                  size="small"
                >
                    <span>{{ expand.labelExpand }}</span>
                </a-button> -->
          </div>
        </div>
        <a-config-provider :locale="getLocalConfigProvider()">
          <a-table bordered size="small" id="tbl_dtl" :rowKey="(record, index) => { return index; }"
            :columns="modalTax.columns" :dataSource="modalTax.source" :pagination="modalTax.pagination"
            :scroll="{ x: 835 }" :loading="modalTax.loading">
            <template slot="nomor" slot-scope="text, data,index">
              <div class="m-text-align center">{{ index + 1 }}</div>
            </template>
            <template slot="detail" slot-scope="data">
              <div class="m-text-align left">{{ data.detail }}</div>
              <small v-if="data.kode_anggaran"><i>[{{ data.kode_anggaran + "-" + data.item_anggaran }}]</i></small>
            </template>
            <template slot="notrans" slot-scope="data">
              <div class="m-text-align center">{{ data.no_trans }}</div>
            </template>
            <template slot="type" slot-scope="data">
              <div class="m-text-align left">{{ gettitletax(data.tax_type) }}</div>
            </template>
            <template slot="dppvalue" slot-scope="data">
              <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.dpp_value" />
            </template>
            <template slot="value" slot-scope="data">
              <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.tax_value" />
            </template>
            <template slot="action" slot-scope="text,data,index">
              <div :class="'m-text-align center'">
                <a-button-group>
                  <a-tooltip class="m-tooltip-inner" placement="bottomRight" title="View File">
                    <a-button
                      :disabled="data.tax_document_name == '' || data.tax_document_name == null || loading.spinform"
                      type="default" @click="viewFiledtl(data.tax_document_name, data.tax_document_path)" icon="file"
                      size="small">
                    </a-button>
                  </a-tooltip>
                </a-button-group>
              </div>
            </template>
            <!-- <template slot="footer">
                <a-row :gutter="16">
                  <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                    <a-statistic
                      title="Total Deduction"
                      :value="formatCurrency('IDR', totalVerificationdtl)"
                      class="m-text-align left"
                    />
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                    <a-statistic
                      title="Real Value AR"
                      :value="formatCurrency('IDR', realAR ? realAR : 0)"
                      class="m-text-align left"
                    />
                  </a-col>
                </a-row>
              </template> -->
          </a-table>
        </a-config-provider>
      </a-modal>

      <a-modal v-model="modalPembetulan.visible" v-if="modalPembetulan.visible" :maskClosable="false" :width="'60%'">
        <span slot="title"> <a-icon type="reconciliation" />&nbsp;
          {{ modalPembetulan.jns == 'manifest' ? 'Manifest' : 'Create' }} Retricfication Tax
          : Document Faktur | {{ modalPembetulan.current_no_trans }} </span>
        <a-form :form="formpembetulan">
          <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Type Document">
                <a-select placeholder="Select Type Rectification" @change="chooseRectification" class="width-full"
                  allowClear showSearch :filter-option="filterOption" v-model="modalPembetulan.type_rectification"
                  :disabled="modalPembetulan.jns == 'manifest'">
                  <a-select-option value="rectification_value">Rectification Value</a-select-option>
                  <a-select-option value="rectification_non_value">Rectification Non Value</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <div class="container-essential">
                <a-form-item label="Current No Document">
                  <a-input disabled v-decorator="[
                    'current_no_document',
                    {
                      rules: [{ required: false }],
                      initialValue: modalPembetulan.current_no_document,
                    },
                  ]" />
                </a-form-item>
                <a-form-item label="Current Document Date">
                  <a-input disabled v-decorator="[
                    'current_document_date',
                    {
                      rules: [{ required: false }],
                      initialValue: moment(modalPembetulan.current_document_date).format(getDefaultDateFormat),
                    },
                  ]" />
                </a-form-item>
                <a-form-item label="Current Document File">
                  <a-upload v-if="modalPembetulan.current_document_file" :fileList="modalPembetulan.current_document_file"
                    v-decorator="[
                      'current_document_file',
                      {
                        rules: [
                          { required: false, },
                        ],
                      },
                    ]">
                  </a-upload>
                  <div v-else class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-text">
                    (None)
                  </div>
                </a-form-item>
                <a-form-item label="Current Document Value">
                  <a-input-number disabled v-decorator="[
                    'current_document_value',
                    { rules: [{ required: false }], initialValue: modalPembetulan.current_document_value },
                  ]" :formatter="(value) => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')" class="m-width-full m-text-align right" />
                </a-form-item>
              </div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-row :gutter="12" v-if="modalPembetulan.type_rectification == 'rectification_value'">
                <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                  <div class="container-essential">
                    <a-form-item label="New No Document">
                      <a-select placeholder="Choose New No Document" @change="handleChangeNewDoc" class="width-full"
                        allowClear showSearch :filter-option="filterOption" v-decorator="[
                          'new_no_document',
                          {
                            rules: [{ required: true }],
                            initialValue: modalPembetulan.new_no_document,
                          },
                        ]" :disabled="modalPembetulan.jns == 'manifest'">
                        <a-icon slot="suffixIcon" type="loading" v-if="modalPembetulan.newdocLoading" />
                        <a-select-option v-for="item in modalPembetulan.list" :key="item.id_tax_transaction"
                          :value="item.id_tax_transaction">
                          {{ item.new_no_document }} | {{ item.new_no_trans }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                    <a-form-item label="New Document Date">
                      <a-input disabled v-decorator="[
                        'new_document_date',
                        { rules: [{ required: false }], initialValue: modalPembetulan.new_document_date },
                      ]" />
                    </a-form-item>
                    <a-form-item label="New Document File">
                      <a-upload v-if="modalPembetulan.new_document_file" :fileList="modalPembetulan.new_document_file"
                        v-decorator="[
                          'new_document_file',
                          {
                            rules: [
                              { required: false, },
                            ],
                          },
                        ]">
                      </a-upload>
                      <div v-else
                        class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-text">
                        (None)
                      </div>
                    </a-form-item>
                    <a-form-item label="New Document Value">
                      <a-input-number v-decorator="[
                        'new_document_value',
                        { rules: [{ required: true }], initialValue: modalPembetulan.new_document_value },
                      ]" :formatter="(value) => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')" class="m-width-full m-text-align right" />
                    </a-form-item>
                  </div>
                </a-col>
              </a-row>
              <a-row :gutter="12" v-else>
                <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                  <div class="container-essential">
                    <a-form-item label="New Document Date">
                      <a-date-picker placeholder="Select New Document Date" :format="getDefaultDateFormat" v-decorator="[
                        'new_document_date',
                        { rules: [{ required: true }], initialValue: modalPembetulan.new_document_date },
                      ]" />
                    </a-form-item>
                    <a-form-item label="New No Document">
                      <a-input v-decorator="[
                        'new_no_document',
                        { rules: [{ required: true }] },
                      ]" />
                    </a-form-item>
                    <a-form-item label="Upload New Document">
                      <a-upload :fileList="modalPembetulan.new_document_file" v-decorator="[
                        'upload_new_document',
                        {
                          rules: [
                            { required: true, validator: doc_validation_new },
                          ],
                        },
                      ]" :beforeUpload="beforeUploadAttachment_new">
                        <a-button> <a-icon type="upload" />Select File </a-button>
                      </a-upload>
                    </a-form-item>
                  </div>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
              <a-form-item label="Note">
                <a-textarea placeholder="Write the note here ... " :rows="2" v-decorator="[
                  'note',
                  { rules: [{ required: true }], initialValue: modalPembetulan.note },
                ]" :disabled="modalPembetulan.jns == 'manifest'" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <div slot="footer">
          <a-button type="primary" @click="saveRetricfication" :loading="modalPembetulan.save"
            v-if="modalPembetulan.jns != 'manifest'">
            Save
          </a-button>
        </div>
      </a-modal>
    </div>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import shortingArray from "@/mixins/MultishortArray";
import GlobalMethod from "@/mixins/GlobalMethod";
import CheckboxAll from "@/components/CheckboxAllHeader.vue";
import TaxDepositEntry from "@/components/TaxDepositEntry.vue";
import _ from "lodash";

export default {
  name: "account-pay-index",
  mixins: [CurrencyFormat, HandleRoute, shortingArray, GlobalMethod],
  components: { CheckboxAll, TaxDepositEntry },
  data() {
    const columns = {
      listRectification: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 40,
          align: "center",
        },
        {
          title: "No",
          key: "no",
          scopedSlots: { customRender: "no_trans" },
          width: 200,
        },
        {
          title: "Created By",
          key: "createby",
          scopedSlots: { customRender: "createby" },
          width: 150,
        },
        {
          title: "No Rectification",
          key: "norectification",
          dataIndex: "tax_rectification_no",
          align: "center",
          width: 150,
        },
        {
          title: "note",
          key: "note",
          dataIndex: "note",
          width: 150,
        },
        {
          title: "Document Type",
          key: "typedoc",
          align: "center",
          dataIndex: "doc_type",
          width: 150,
        },
        {
          title: "Type Rectification",
          key: "tipe",
          align: "center",
          scopedSlots: { customRender: "tipe" },
          width: 150,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 150,
        },
        {
          title: "Action",
          fixed: "right",
          scopedSlots: { customRender: "aksi" },
          align: "center",
          width: 150,
        },
      ],
      needProcess: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 40,
          align: "center",
        },
        {
          title: "No",
          key: "no",
          scopedSlots: { customRender: "no_trans" },
          width: 250,
        },
        {
          title: "Date Document",
          key: "date",
          align: "center",
          scopedSlots: { customRender: "trans_dt" },
          width: 100,
        },
        {
          title: "No Document",
          key: "nodoc",
          align: "center",
          dataIndex: "no_document",
          width: 150,
        },
        {
          title: "Document Type",
          key: "typedoc",
          align: "left",
          dataIndex: "type_document",
          width: 150,
        },
        {
          title: "Description",
          key: "description",
          dataIndex: "description",
          width: 200,
        },
        {
          title: "Type",
          key: "type",
          dataIndex: "type_label",
          width: 125,
        },
        // {
        //   title: "TLC",
        //   key: "tlc",
        //   dataIndex: "tlc",
        //   scopedSlots: { customRender: "tlc" },
        //   width: 75,
        // },
        // {
        //   title: "Value DPP",
        //   key: "value_dpp",
        //   scopedSlots: { customRender: "value_dpp" },
        //   width: 150,
        // },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 150,
        },
        // {
        //   title: "Deposite Code / Tax Object",
        //   key: "object_deposite",
        //   scopedSlots: { customRender: "object_deposite" },
        //   width: 200,
        // },
        // {
        //   title: "Tax Type",
        //   key: "tax_type",
        //   dataIndex: "tax_type_label",
        //   width: 125,
        // },
        {
          title: "Created By",
          key: "createby",
          scopedSlots: { customRender: "createby" },
          width: 150,
        },
        {
          title: "Document tax",
          key: "document_tax",
          scopedSlots: { customRender: "document_tax" },
          width: 200,
        },
        {
          title: "Action",
          fixed: "right",
          scopedSlots: { customRender: "aksi" },
          align: "center",
          width: 150,
        },
      ],
    };
    let doc_validation = (rule, value, callback) => {
      if (this.modalData.fileList && this.modalData.fileList == null) {
        callback(new Error("Please Complete Your Form Input!"));
      } else {
        callback();
      }
    };
    let
      doc_validation_new = (rule, value, callback) => {
        if (this.modalPembetulan.new_document_file && this.modalPembetulan.new_document_file == null) {
          callback(new Error("Please Complete Your Form Input!"));
        } else {
          callback();
        }
      };
    return {
      doc_validation,
      doc_validation_new,
      columns,
      pageLoading: false,
      loading: {
        modalDepositKey: "",
        modalDeposit: false,
        create: false,
        createtaxmanual: false,
        deletetaxmanual: false,
      },
      tabs: {
        active: "needprocess",
        loading: false,
      },
      needProcess: [],
      listRectification: [],
      needProcess_origin: [],
      listRectification_origin: [],
      search: undefined,
      typetransaction: "all",
      type: "all",
      recavai: "all",
      doctype: "all",
      transactionDt: [],
      taxDt: [],
      buktiTransfer: [],
      modalDepositEntry: false,
      advancedsearch: "display:none",
      needProcessSuplier: [],
      quequeSuplier: [],
      releaseSuplier: [],
      listSuplier: [],
      stsDocument: "all",
      dataEdit: [],
      modalCreate: false,
      modalData: {
        costcenter: [],
        costcenterOri: [],
        jenis_anggaran: [],
        kode_anggaran: [],
        kode_anggaranOri: [],
        peruntukan: [],
        peruntukanOri: [],
        sub_peruntukan: [],
        sub_peruntukanOri: [],
        treeExpandedKeys: [],
        anggaran: {
          tree: [],
          loadingtree: false,
        },
        listsetoranpajak: [],
        listobjekpajak: [],
        fileList: [],
      },
      urlgetObjec_setran_pajak: "tax_transaction/objek_setoran_pajak",
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      paginationlist: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      modalTaxVerification: false,
      modalTax: {
        jenis_transaksi_label: "-",
        no_transaction: "",
        source: [],
        pagination: {
          onChange: (page) => {
            this.modalTax.pagination.page = page;
          },
          page: 1,
          pageSize: 10,
          size: "small",
        },
        columns: [
          {
            title: "#",
            key: "nomor",
            scopedSlots: { customRender: "nomor" },
            width: 50,
          },
          {
            title: "No. Transaction",
            key: "notrans",
            scopedSlots: { customRender: "notrans" },
            width: 150,
          },
          {
            title: "Detil transaction",
            key: "detail",
            scopedSlots: { customRender: "detail" },
            width: 250,
          },
          {
            title: "Type tax",
            key: "type",
            scopedSlots: { customRender: "type" },
            width: 150,
          },
          {
            title: "DPP Value",
            key: "dppvalue",
            scopedSlots: { customRender: "dppvalue" },
            width: 150,
          },
          {
            title: "Value",
            key: "value",
            scopedSlots: { customRender: "value" },
            width: 150,
          },
          {
            title: "View",
            key: "action",
            align: "center",
            scopedSlots: { customRender: "action" },
            width: 85,
          },
        ],
      },
      modalPembetulan: {
        visible: false,
        key: "",
        loading: false,
        type_rectification: "rectification_value",
        list: [],
        newdocLoading: false,
      },
    };
  },
  beforeCreate() {
    this.formDepositEntry = this.$form.createForm(this);
    this.formcreate = this.$form.createForm(this);
    this.formpembetulan = this.$form.createForm(this);
  },
  mounted() {
    Event.$on("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$on("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
    Event.$on("confirmMessageDelete", this.delete);
    this.$store.dispatch("Fetch_TYPE_TAX");
    if (this.isAkuntansi) {
      this.tabs.active = "release";
    }
  },
  beforeDestroy() {
    Event.$off("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$off("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
    Event.$off("confirmMessageDelete", this.delete);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getType_tax",
    ]),
    isAkuntansi() {
      return this.$route.name == "Spclaccount-pay-index" &&
        this.$route.path == "/akuntansiKeuangan/account_pay"
        ? true
        : false;
    },
    moreSearch: function () {
      let tempData = [];
      if (this.tabs.active == "list_tax_rectification") {

        tempData = this.listRectification_origin;
      } else {
        tempData = this.needProcess_origin;
      }

      if (tempData.length > 0) {
        if (this.search && this.tabs.active == "list_tax_rectification") {
          tempData = tempData.filter(
            (obj) =>
              (obj.no_trans &&
                obj.no_trans.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.description &&
                obj.description
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_document &&
                obj.no_document
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tax_type_label &&
                obj.tax_type_label
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency("IDR", obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value_dpp &&
                this.formatCurrency("IDR", obj.value_dpp)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tax_date &&
                this.moment(obj.tax_date)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
          this.intoList(this.tabs.active, tempData);
        } else if (this.search && this.tabs.active == "needprocess") {
          tempData = tempData.filter(
            (obj) =>
              (obj.no_trans &&
                obj.no_trans.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.description &&
                obj.description
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_document &&
                obj.no_document
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tax_type_label &&
                obj.tax_type_label
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency("IDR", obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value_dpp &&
                this.formatCurrency("IDR", obj.value_dpp)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tax_date &&
                this.moment(obj.tax_date)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
          this.intoList(this.tabs.active, tempData);
        }

        if (this.type && this.type !== "all") {
          tempData = tempData.filter(
            (obj) =>
              obj.type &&
              obj.type.toLowerCase() == this.type.toLowerCase()
          );
        }

        if (this.typetransaction && this.typetransaction !== "all") {
          //console.log("this.typetransaction",this.typetransaction)
          tempData = tempData.filter(
            (obj) =>
              obj.tax_type &&
              obj.tax_type.toLowerCase() == this.typetransaction.toLowerCase()
          );
        }

        if (this.recavai && this.recavai !== "all") {
          tempData = tempData.filter(
            (obj) =>
              obj.pembetulan &&
              obj.pembetulan.toLowerCase() == this.recavai.toLowerCase()
          );
        }

        if (this.doctype && this.doctype !== "all") {
          tempData = tempData.filter(
            (obj) =>
              obj.type_document &&
              obj.type_document.toLowerCase() == this.doctype.toLowerCase()
          );
        }

        if (this.transactionDt && this.transactionDt.length > 0) {
          //console.log(this.transactionDt[0],this.transactionDt[1])
          let startDt = moment(this.transactionDt[0]).format("YYYY-MM-DD");
          let endDt = moment(this.transactionDt[1]).format("YYYY-MM-DD");
          tempData = tempData.filter(
            (obj) =>
              obj.trans_dt &&
              moment(obj.trans_dt).format("YYYY-MM-DD") >= startDt &&
              moment(obj.trans_dt).format("YYYY-MM-DD") <= endDt
          );
        }

        if (this.taxDt && this.taxDt.length > 0) {
          //console.log(this.transactionDt[0],this.transactionDt[1])
          let startDt = moment(this.taxDt[0]).format("YYYY-MM-DD");
          let endDt = moment(this.taxDt[1]).format("YYYY-MM-DD");
          tempData = tempData.filter(
            (obj) =>
              obj.tax_date &&
              moment(obj.tax_date).format("YYYY-MM-DD") >= startDt &&
              moment(obj.tax_date).format("YYYY-MM-DD") <= endDt
          );
        }

        if (this.stsDocument != "" && this.stsDocument != undefined) {
          if (this.stsDocument == "yes") {
            tempData = tempData.filter(
              (obj) =>
                obj.document_sts && obj.document_sts == "Document Complete"
            );
          } else if (this.stsDocument == "no") {
            tempData = tempData.filter(
              (obj) =>
                obj.document_sts && obj.document_sts == "Document Not Complete"
            );
          }
        }
      }
      this.intoList(this.tabs.active, tempData);
      if (
        !this.tabs.active &&
        !this.search &&
        !this.transactionDt &&
        !this.taxDt &&
        !this.type &&
        !this.typetransaction &&
        !this.recavai &&
        !this.doctype
      ) {
        this.intoList(this.tabs.active, tempData);
      }
      return true;
    },
    listtax() {
      return _.filter(this.getType_tax, (el) => el.value !== "bea_masuk");
    },
  },
  created() {
    this.handleReload();
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.search = undefined;
      this.transactionDt = undefined;
      this.taxDt = undefined;
      this.typetransaction = "all";
      this.stsDocument = "all";
      this.recavai = "all";
      this.doctype = "all";
    },
    intoList(type, value) {
      if (type == "release") {
        this.release = value;
      } else if (type == "queue") {
        this.queue = value;
      } else {
        this.needProcess = value;
      }
    },
    handleReload() {
      this.pageLoading = true;
      this.asyncAxiosGet("Faktur", this.getAuth, {
        tlc: this.getAuth.username,
        tab: this.tabs.active,
      })
        .then((res) => {
          if (this.tabs.active == "list_tax_rectification") {
            this.listRectification = res.data;
            this.listRectification_origin = res.data;
          } else {
            this.needProcess = res.data;
            this.needProcess_origin = res.data;
          }
          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
      this.resetSearch();
    },
    handleTab(val) {
      this.tabs.active = val;
      this.resetSearch();
      this.handleReload();
    },
    handleCreate(item) {
      this.$router.push({
        name: "account-pay-create",
        params: { id: item.id, type: item.jenis_id },
      });
    },
    handleCreateAddendum(item) {
      this.$router.push({
        name: "createAddendum",
        params: { id: item.id, jenis_transaksi: item.jenis_transaksi },
      });
    },
    handleRelease(item) {
      this.$store
        .dispatch("releaseQueue", {
          auth: this.getAuth,
          id_ap: item.id_account_pay,
          id: item.id,
          jenis_transaksi: item.jenis_transaksi,
        })
        .then((res) => {
          this.$router.go();
          this.displayMessage("success-release");
        });
    },
    handleManifestRef(item) {
      const data = {
        rest_api:
          item.jenis_transaksi.toLowerCase() == "adendum"
            ? item.jenis_transaksi.toLowerCase()
            : "accountpay",
        id_manifest:
          item.jenis_transaksi.toLowerCase() == "adendum"
            ? item.id
            : item.id_account_pay,
        tlc: this.getAuth.username,
        user_pembuat: item.tlc_create,
      };

      this.handleView(data);
    },
    handleshowModalDeposit(item) {
      if (item.type == "tax_manual") {
        this.loading.modalDepositKey = item.id_tax_transaction;
        this.loading.modalDeposit = true;
        this.modalData.modeedit = true;

        this.asyncAxiosGet("tax_transaction/edit", this.getAuth, {
          id_transaction: item.id_transaction,
        })
          .then((response) => {
            this.dataEdit = response;
            this.dataEdit.treekode_anggaran = response.peruntukan + ";" + response.sub_peruntukan + ";" + response.kode_anggaran;

            this.asyncAxiosGet("main/cost_center", this.getAuth, {
              tlc: this.getAuth.username,
            })
              .then((res) => {
                this.modalData.costcenterOri = res.cost_center;
                this.modalData.costcenter = res.cost_center;
                this.modalData.kode_anggaranOri = res.kode_anggaran;
                this.modalData.jenis_anggaran = res.jenis_anggaran;
                this.modalData.peruntukanOri = res.peruntukan;
                this.modalData.peruntukan = _.filter(res.peruntukan, (el) => el.anggaran_id == this.dataEdit.cost_center);
                this.modalData.sub_peruntukanOri = res.sub_peruntukan;
                this.modalData.sub_peruntukan = res.sub_peruntukan;

                this.asyncAxiosGet("tax_transaction/tree_anggaran", this.getAuth, {
                  anggaran_id: this.dataEdit.cost_center,
                  peruntukan_id: this.dataEdit.peruntukan,
                })
                  .then((res) => {
                    this.modalData.anggaran.tree = res.tree;
                    this.modalData.treeExpandedKeys = this.getParent(
                      this.modalData.anggaran.tree
                    );
                    this.modalData.anggaran.loadingtree = false;
                  })
                  .catch((err) => {
                    this.modalData.anggaran.loadingtree = false;
                    let responses = Object.assign({}, err.response.data);
                    this.displayMessageValue("error-other", responses.message);
                  });

                this.asyncAxiosGet(
                  this.urlgetObjec_setran_pajak,
                  this.getAuth,
                  { tlc: this.getAuth.username }
                )
                  .then((res2) => {
                    this.modalData.listsetoranpajak = res2.setoran;
                    this.modalData.listobjekpajak = res2.objek;

                    this.loading.modalDepositKey = "";
                    this.loading.modalDeposit = false;

                    // this.dataEdit.type_document
                    // this.dataEdit.no_document
                    // this.dataEdit.tgl_document

                    if (
                      this.dataEdit.file_document_tax &&
                      this.dataEdit.file_document_tax != "No File Uploaded"
                    ) {
                      let typefile = this.fileTypeFromUrl(
                        this.dataEdit.file_document_tax
                      );
                      let file = this.dataURLtoFile(
                        typefile + this.dataEdit.file_document,
                        this.dataEdit.file_document_tax
                      );
                      file.uid = "vc-upload-1-1";
                      file.status = "done";
                      file.url =
                        this.$serviceUrl + this.dataEdit.path_document_tax;
                      this.modalData.fileList = [];
                      this.modalData.fileList.push(file);
                    } else {
                      this.modalData.fileList = [];
                    }
                    this.modalCreate = !this.modalCreate;
                  })
                  .catch((err) => {
                    this.loading.modalDepositKey = "";
                    this.loading.modalDeposit = false;
                    let responses = Object.assign({}, err.response.data);
                    this.displayMessageValue("error-other", responses.message);
                  });
              })
              .catch((err) => {
                this.loading.create = false;
                let responses = Object.assign({}, err.response.data);
                this.displayMessageValue("error-other", responses.message);
              });
          })
          .catch((err) => {
            this.loading.modalDepositKey = "";
            this.loading.modalDeposit = false;
            console.log(err);
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      } else {
        this.loading.modalDepositKey = item.id_tax_transaction;
        this.loading.modalDeposit = true;
        this.dataEdit = item;

        this.asyncAxiosGet(this.urlgetObjec_setran_pajak, this.getAuth, {
          tlc: this.getAuth.username,
        })
          .then((res) => {
            this.dataEdit.listsetoranpajak = res.setoran;
            this.dataEdit.listobjekpajak = res.objek;

            if (item.document_tax && item.document_tax != "No File Uploaded") {
              this.asyncAxiosGet("main/base_64", this.getAuth, {
                path: item.document_path,
              })
                .then((response) => {
                  let typefile = this.fileTypeFromUrl(item.document_tax);
                  let file = this.dataURLtoFile(
                    typefile + response.file_document_tax,
                    item.document_tax
                  );
                  file.uid = "vc-upload-1-1";
                  file.status = "done";
                  file.url = this.$serviceUrl + item.document_path;
                  this.dataEdit.fileList = [];
                  this.dataEdit.fileList.push(file);

                  this.loading.modalDeposit = false;
                  this.modalDepositEntry = !this.modalDepositEntry;
                })
                .catch((err) => {
                  console.log(err);
                  let responses = Object.assign({}, err.response.data);
                  this.displayMessageValue("error-other", responses.message);
                });
            } else {
              this.loading.modalDeposit = false;
              this.modalDepositEntry = !this.modalDepositEntry;
            }
          })
          .catch((err) => {
            this.loading.modalDeposit = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      }
    },
    handleManifest(item) {
      if (item.jenis_transaksi == "Adendum") {
        this.$router.push({
          name: "AddendumManifest",
          params: { id: item.id },
        });
      } else {
        if (this.isAkuntansi) {
          this.$router.push({
            name: "Spclaccount-pay-manifest",
            params: { id: item.id_account_pay },
          });
        } else {
          this.$router.push({
            name: "account-pay-manifest",
            params: { id: item.id_account_pay },
          });
        }
      }
    },
    handleManifestQueue(item) {
      if (item.jenis_transaksi == "Adendum") {
        this.$router.push({
          name: "AddendumManifest",
          params: { id: item.id },
        });
      } else {
        if (this.isAkuntansi) {
          this.$router.push({
            name: "Spclaccount-pay-manifest",
            params: { id: item.id_account_pay },
          });
        } else {
          this.$router.push({
            name: "account-pay-manifest",
            params: { id: item.id_account_pay },
          });
        }
      }
    },
    handleDocument(item) {
      this.$store
        .dispatch("getBuktiAP", { auth: this.getAuth, id: item.id })
        .then((res) => {
          this.buktiTransfer = res.data.data;
          this.modalDepositEntry = true;
        });
    },
    handleDownload(item) {
      window.open(this.$serviceUrl + item.url, "_blank");
    },
    handleClose() {
      this.modalDepositEntry = false;
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },

    handleRevisiAndClose(item) {
      const that = this;
      let title = "";
      let messageSukses = "";
      title = "Are you sure to revise this data";
      messageSukses = "Successfully revise data";

      this.$confirm({
        title: title,
        content: "Batal / OK?",
        onOk() {
          let promise = new Promise((resolve, reject) => {
            let data = {
              tlc: that.getAuth.username,
              aksi: item.button_aksi,
              id: item.id,
              jenis_transaksi: item.jenis_transaksi,
            };

            // try {
            //   resolve(data);
            // } catch {
            //   reject("error data");
            // }

            axios({
              method: "post",
              url: that.$serviceUrl + "account_pay/aksi_account_pay",
              data: data,
              auth: {
                username: that.getAuth.username,
                password: that.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": that.getAuth.apikey,
              },
            })
              .then(({ data, status }) => {
                resolve(data);
              })
              .catch((err) => {
                reject(err);
              });
          }).catch(() => console.log("Oops errors!"));
          promise
            .then((value) => {
              that.displayMessageValue("success-other", messageSukses);
              that.handleReload();
            })
            .then((err) => {
              if (err) {
                let responses = Object.assign({}, err.response.data);
                that.displayMessageValue("error-other", responses.message);
              }
            });
          return promise;
        },
        onCancel() { },
      });
    },

    handleviewAttacment(item) {
      window.open(this.$serviceUrl + item.document_path);
    },
    handledatachecked() { },
    taxDepositEntryCancel() {
      this.dataEdit = [];
      this.modalDepositEntry = !this.modalDepositEntry;
    },
    handleShowModalCreate() {
      this.dataEdit = [];
      this.dataEdit = [];
      this.modalData.anggaran.tree = [];
      this.modalData.costcenterOri = [];
      this.modalData.costcenter = [];
      this.modalData.kode_anggaranOri = [];
      this.modalData.jenis_anggaran = [];
      this.modalData.peruntukanOri = [];
      this.modalData.peruntukan = [];
      this.modalData.sub_peruntukanOri = [];
      this.modalData.sub_peruntukan = [];
      this.modalData.fileList = [];
      this.modalData.modeedit = false;

      this.loading.create = true;
      this.asyncAxiosGet("main/cost_center", this.getAuth, {
        tlc: this.getAuth.username,
      })
        .then((res) => {
          this.modalData.costcenterOri = res.cost_center;
          this.modalData.jenis_anggaran = res.jenis_anggaran;
          this.modalData.kode_anggaranOri = res.kode_anggaran;
          this.modalData.peruntukanOri = res.peruntukan;
          this.modalData.sub_peruntukanOri = res.sub_peruntukan;

          this.asyncAxiosGet(this.urlgetObjec_setran_pajak, this.getAuth, {
            tlc: this.getAuth.username,
          })
            .then((res) => {
              this.modalData.listsetoranpajak = res.setoran;
              this.modalData.listobjekpajak = res.objek;

              this.loading.create = false;
              this.modalCreate = !this.modalCreate;
            })
            .catch((err) => {
              this.loading.create = false;
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
            });
        })
        .catch((err) => {
          this.loading.create = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    handleModalCreate() {
      this.modalCreate = !this.modalCreate;
    },
    handleModalClose() {
      this.modalCreate = !this.modalCreate;
    },
    handleJenisAnggaran(e) {
      this.formcreate.setFieldsValue({
        cost_center: null,
        peruntukan: null,
        sub_peruntukan: null,
        kode_anggaran: null,
      });
      const filter = this.modalData.costcenterOri.filter(
        (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.modalData.costcenter = filter;
      this.modalData.peruntukan = [];
      // this.anggaran.tree = [];
      // this.anggaran.treeModal = [];
      this.modalData.subPeruntukan = [];
    },
    handleCost(e) {
      this.$nextTick(function () {
        this.formcreate.setFieldsValue({
          peruntukan: null,
          sub_peruntukan: null,
          kode_anggaran: null,
        });
      });
      this.modalData.subPeruntukan = [];
      // this.modalData.anggaran.tree = [];
      // this.modalData.anggaran.treeModal = [];
      const peruntukan = this.modalData.peruntukanOri.filter(
        (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.modalData.peruntukan = peruntukan;
      // this.modalData.anggaran.anggaran_id = e;
      // this.modalData.data.cost_center_id = e;
    },
    handle_Peruntukan(e) {
      this.modalData.anggaran.loadingtree = true;
      let params = this.formcreate.getFieldsValue();
      this.asyncAxiosGet("tax_transaction/tree_anggaran", this.getAuth, {
        anggaran_id: params.cost_center,
        peruntukan_id: e,
      })
        .then((res) => {
          this.modalData.anggaran.tree = res.tree;
          this.modalData.treeExpandedKeys = this.getParent(
            this.modalData.anggaran.tree
          );
          this.modalData.anggaran.loadingtree = false;
        })
        .catch((err) => {
          this.modalData.anggaran.loadingtree = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    getParent(root) {
      let data = [];
      root.forEach((item) => {
        if (item.key) {
          data.push(item.key);
        }

        if (item.children.length > 0) {
          item.children.forEach((d) => {
            data.push(d.key);
          });
        }
      });
      return data;
    },
    handlechoiceCost(item) {
    },
    filterTreeNode(input, option) {
      //console.log(input, option)
      return (
        option.data.props.texttitle == undefined ||
        (option.data.props.texttitle ? option.data.props.texttitle : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangeTaxType(e) {
      this.modalData.reftax_type = e;
    },
    preventEnterButton() {
      //antisipasi tekan enter karena bisa mengkacaukan validator minus dikomponennya
      this.$nextTick(function () {
        this.$refs.addMainBtn.$children[0].$el.focus();
      });
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    beforeUploadAttachment(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.modalData.fileList = [];
        this.modalData.fileList.push(file);

        this.$nextTick(function () {
          this.formcreate.setFieldsValue({
            type_document: null,
            no_document: null,
            tgl_document: null,
          });
        });
        return false;
      }
    },
    handleRemoveAttachment() {
      this.modalData.fileList = [];
      this.modalData.type_document = null;
      this.modalData.no_document = null;
      this.modalData.tgl_document = null;
    },
    handleCreateTaxManual() {
      this.formcreate.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        this.loading.createtaxmanual = true;
        let data = new FormData();
        if (this.dataEdit && this.dataEdit.id_transaction)
          data.append("id_transaction", this.dataEdit.id_transaction);
        data.append("tlc", this.getAuth.username);
        data.append(
          "date_of_tax",
          moment(values.tax_date).format("YYYY-MM-DD")
        );
        data.append("type_pajak", values.tax_type);
        data.append("tax_deposit", values.kode_setoran_pajak ? values.kode_setoran_pajak : "");
        let newCode = values.kode_anggaran.split(";");
        data.append("kode_anggaran", newCode[newCode.length - 1]);
        data.append("tax_value", values.value);
        data.append("tax_object", values.objek_pajak ? values.objek_pajak : "");
        data.append("description", values.description ? values.description : "");
        data.append("dpp_value", values.dpp_value);
        if (this.modalData.fileList.length > 0)
          data.append("file_document_tax", this.modalData.fileList[0]);

        if (this.modalData.modeedit && this.modalData.fileList.length > 0) {
          data.append("tgl_document", moment(values.tgl_document).format(this.getStandartFormatDate));
          data.append("type_document", values.type_document);
          data.append("no_document", values.no_document);
        }

        let url = "";
        if (this.dataEdit && this.dataEdit.id_transaction) {
          url = "Tax_transaction/edit";
        } else {
          url = "Tax_transaction";
        }

        this.asyncAxiosPost(url, "formdata", this.getAuth, data)
          .then(() => {
            this.loading.createtaxmanual = false;
            this.modalCreate = !this.modalCreate;
            this.displayMessage("success-save");
            this.handleReload();
          })
          .catch((err) => {
            console.log(err);
            this.modalCreate = !this.modalCreate;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
            this.loading.createtaxmanual = false;
          });
      });
    },
    taxDepositEntryUpdate() {
      this.modalData.fileList = [];
      this.modalData.type_document = null;
      this.modalData.no_document = null;
      this.modalData.tgl_document = null;
      this.handleReload();
    },
    handleDeleteModalDeposit(item) {
      this.confirmMessageValue("confirm-delete", item);
    },
    delete(item) {
      this.loading.deletetaxmanual = true;
      this.loading.modalDepositKey = item.id_transaction;

      this.asyncAxiosDelete(
        "Tax_transaction",
        "application/json",
        this.getAuth,
        { id_transaction: item.id_transaction }
      )
        .then(() => {
          this.loading.deletetaxmanual = false;
          this.loading.modalDepositKey = "";
          this.displayMessage("success-save");
          this.handleReload();
        })
        .catch((err) => {
          console.log(err);
          this.loading.deletetaxmanual = false;
          this.loading.modalDepositKey = "";
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    handlelinkNo(item) {
      item.rest_api = item.type.toLowerCase();
      item.id_manifest = item.id_transaction;
      item.user_pembuat = item.tlc;
      item.tab = "release";
      item.jns = "Penerimaan_Kontrak";
      item.jenis = "Penerimaan_Kontrak";
      this.handleView(item, true);
    },
    handlelinkTaxVerivication(item) {
      this.modalTaxVerification = true;
      this.modalTax.loading = true;
      this.asyncAxiosGet("tax_verification", this.getAuth, {
        id_transaksi: item.id_transaction,
        jenis_transaksi: item.type
      })
        .then((res) => {
          //     this.modalData.costcenterOri = res.cost_center;
          // this.modalData.id_header = res.id_header;
          this.modalTax.source = res.list_tax_dtl;
          this.modalTax.jenis_transaksi_label = res.jenis_transaksi_lbl;
          this.modalTax.no_transaction = res.no_transaction;
          // for (let w = 0; w < this.modalData.detil_transaction.length; w++) {
          //   this.modalData.detil_transaction[w].disabled = false;
          // }
          //this.modalData.listsetoranpajak = res.setoran;
          // this.modalData.listsetoranpajakOri = res.setoran;
          // this.modalData.listobjekpajak = res.objek;
          // if (res.list_tax_dtl) {
          //   this.verificationdtl_source = res.list_tax_dtl;
          //   for (let x = 0; x < this.verificationdtl_source.length; x++) {
          //     if (this.verificationdtl_source[x].id == undefined)
          //       this.verificationdtl_source[x].id = this.verificationdtl_source[x].id_dtl;
          //   }
          // }
          // this.dtlmodalchange();

          // this.loading.create = false;
          // this.modalProcess = !this.modalProcess;
          // this.loading.modalProcess = false;

          this.modalTax.loading = false;
        })
        .catch((err) => {
          this.modalTax.loading = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    gettitletax(val) {
      let res = _.filter(this.getType_tax, (el) => el.value == val);
      return res.length > 0 ? res[0].text : "-";
    },
    modalTaxVerificationClose() {
      this.modalTax.jenis_transaksi_label = "-";
      this.modalTax.no_transaction = "";
      this.modalTax.source = [];
    },
    handleRectification(jns, data) {
      this.modalPembetulan.loading = true;
      this.modalPembetulan.key = (jns == "transaction" ? data.id_tax_transaction : data.tax_rectification_id);
      let url = (jns == "transaction" ? "faktur/create" : "faktur/pembetulan_faktur");
      let params = jns == "transaction" ? {
        id_tax_transaction: data.id_tax_transaction,
        tax_type: data.tax_type
      } : {
        tax_rectification_id: data.tax_rectification_id,
        tax_type: data.tax_type
      };
      this.asyncAxiosGet(url, this.getAuth, params)
        .then((response) => {
          this.modalPembetulan['current_document_type'] = response.current_document_type;
          this.modalPembetulan['current_no_document'] = response.current_no_document;
          this.modalPembetulan['current_document_date'] = moment(response.current_document_date);
          this.modalPembetulan['current_document_value'] = response.current_document_value;
          this.modalPembetulan['current_no_trans'] = jns == "transaction" ? response.current_no_trans : data.no_trans;
          this.modalPembetulan['id_tax_transaction'] = response.id_tax_transaction;
          this.modalPembetulan['new_document_file'] = null;
          this.modalPembetulan['current_document_file_doc'] = null;
          this.modalPembetulan['jns'] = jns;

          this.modalPembetulan['new_no_document'] = jns == "transaction" ? (response.new_no_document ? response.new_no_document : null) :
            (response.no_new_document_value ? response.no_new_document_value : null);
          this.modalPembetulan['new_document_date'] = response.new_document_date ? moment(response.new_document_date).format(this.getDefaultDateFormat) : null;
          this.modalPembetulan['new_document_value'] = response.new_document_value ? response.new_document_value : null;
          this.modalPembetulan['note'] = response.note ? response.note : null;

          this.modalPembetulan.list = response.no_new_document;
          if (response.current_document_file_doc != "No File Upload") {
            let typefile = this.fileTypeFromUrl(response.current_document_file_name);
            let file = this.dataURLtoFile(
              typefile + response.current_document_file_doc,
              response.current_document_file_name
            );
            file.uid = "vc-upload-1-1";
            file.status = "done";
            file.url = this.$serviceUrl + response.current_document_file_path;
            this.modalPembetulan.current_document_file = [];
            this.modalPembetulan.current_document_file.push(file);
          }
          if (response.new_document_file_doc && response.new_document_file_doc != "No File Upload") {
            let typefile = this.fileTypeFromUrl(response.new_document_file_name);
            let file = this.dataURLtoFile(
              typefile + response.new_document_file_doc,
              response.new_document_file_name
            );
            file.uid = "vc-upload-1-1";
            file.status = "done";
            file.url = this.$serviceUrl + response.current_document_file_path;
            this.modalPembetulan.new_document_file = [];
            this.modalPembetulan.new_document_file.push(file);
          }

          this.modalPembetulan.loading = false;
          this.modalPembetulan.key = "";
          this.modalPembetulan.visible = true;
        })
        .catch((err) => {
          this.modalPembetulan.loading = false;
          this.modalPembetulan.key = "";
          console.log(err);
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    chooseRectification() {
      this.modalPembetulan.new_document_file = null;
    },
    handleChangeNewDoc(id) {
      if (id) {
        this.modalPembetulan.newdocLoading = true;
        this.modalPembetulan.new_document_file = null;
        let news = _.filter(this.modalPembetulan.list, (el) => el.id_tax_transaction == id);
        this.$nextTick(function () {
          this.formpembetulan.setFieldsValue({
            new_document_date: moment(news[0].new_document_date, this.getStandartFormatDate).format(this.getDefaultDateFormat),
            new_document_value: news[0].new_document_value,
          });
        });

        if (news[0].new_document_file) {
          this.asyncAxiosGet("main/base_64", this.getAuth, {
            path: news[0].new_document_file_path,
          })
            .then((response) => {
              let typefile = this.fileTypeFromUrl(news[0].new_document_file);
              let file = this.dataURLtoFile(
                typefile + response.file_document_tax,
                news[0].new_document_file
              );
              file.uid = "vc-upload-1-1";
              file.status = "done";
              file.url = this.$serviceUrl + news[0].new_document_file_path;
              this.modalPembetulan.new_document_file = [];
              this.modalPembetulan.new_document_file.push(file);

              this.modalPembetulan.newdocLoading = false;
            })
            .catch((err) => {
              this.modalPembetulan.newdocLoading = false;
              console.log(err);
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
            });
        } else {
          this.modalPembetulan.new_document_file = [];
        }
      } else {
        this.$nextTick(function () {
          this.formpembetulan.setFieldsValue({
            new_no_document: undefined,
            new_document_date: undefined,
            new_document_value: undefined,
          });
        });
        this.modalPembetulan.new_document_file = [];
      }
    },
    beforeUploadAttachment_new(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.modalPembetulan.new_document_file = [];
        this.modalPembetulan.new_document_file.push(file);
        return false;
      }
    },
    saveRetricfication() {
      this.formpembetulan.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.modalPembetulan.save = true;

        let data = new FormData();
        data.append("id_tax_transaction", this.modalPembetulan.id_tax_transaction);
        data.append("type_rectification", this.modalPembetulan.type_rectification);
        data.append("new_no_document", values.new_no_document);
        data.append("note", values.note);
        if (this.modalPembetulan.type_rectification != 'rectification_value') {
          data.append("new_document_date", moment(values.new_document_date).format("YYYY-MM-DD"));
          data.append("file_upload", this.modalPembetulan.new_document_file[0]);
        }else{
          data.append("new_document_value", values.new_document_value);
        }

        this.asyncAxiosPost("faktur", "formdata", this.getAuth, data)
          .then((response) => {
            this.modalPembetulan.save = false;
            this.modalPembetulan.visible = false;
            if (response.status && response.status == true) {
              this.displayMessageValue("success-other", response.message);
            } else {
              let responses = Object.assign({}, response);
              this.displayMessageValue("error-other", responses);
            }
            this.handleReload();
          })
          .catch((err) => {
            this.modalPembetulan.save = false;
            let response = Object.assign({}, err.response);
            if (response.data.status == false && response.data.message) {
              this.displayMessageValue("error-other", response.data.message);
            } else {
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error", responses);
            }
          });

      });
    }
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);

  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }

  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }

    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead>tr>th {
  text-align: center;
}
</style>
